const TONES = {
  white: "bg-white",
  brandTint: "bg-brand-50",
  sunTint: "bg-sun-50",
  brand: "bg-brand-100",
};

/** One value per prop, so class names never conflict. Full literals for Tailwind. */
const WIDTHS = {
  wide: "max-w-7xl",
  narrow: "max-w-3xl",
};

const SPACING = {
  default: "py-12 sm:py-16 lg:py-20",
  compact: "py-10 sm:py-12 lg:py-14",
  roomy: "py-14 sm:py-20 lg:py-24",
  hero: "pt-8 pb-12 sm:pt-12 sm:pb-14 lg:pt-12 lg:pb-14",
};

/**
 * Standard page section. Mobile-first padding, centred max width, clips decorative shapes.
 * Put an <h2> (SectionHeading) inside; never nest the section in another <section>.
 */
export function Section({
  tone = "white",
  width = "wide",
  spacing = "default",
  id,
  labelledBy,
  className = "",
  innerClassName = "",
  testId,
  children,
}) {
  return (
    <section
      id={id}
      aria-labelledby={labelledBy}
      data-testid={testId}
      className={`relative overflow-hidden ${TONES[tone] ?? TONES.white} ${className}`}
    >
      <div
        className={`relative mx-auto w-full px-4 sm:px-6 lg:px-8 ${WIDTHS[width] ?? WIDTHS.wide} ${
          SPACING[spacing] ?? SPACING.default
        } ${innerClassName}`}
      >
        {children}
      </div>
    </section>
  );
}
